<div class="row mb-3">
  <div class="col-auto">
    <ngx-qrcode
      [value]="qrValue"
      class="aclass"
      width="150px"
      errorCorrectionLevel="M"
      [margin]="0"
    >
    </ngx-qrcode>
  </div>

  <div class="col small my-auto">
    {{ 'document-view-public.document-view-fiscalization.issued-by' | translate }}: {{ document._fina.operatorLabel }} <br><br class="d-md-none d-lg-block">
    <span>{{ 'global.payment-method' | translate }}: {{ paymentMethod | translate }}</span> <br>
    <span>ZKI: {{ document._fina.ZKI }}</span> <br>
    <span>JIR: {{ document._fina.JIR }}</span> <br>
  </div>
</div>